import { useMutation } from '@apollo/client';
import PropTypes from 'prop-types';

import { Toggle } from '@playbookux/playbook-web-core';
import React, { useEffect, useState } from 'react';
import { UPDATE_IS_BANNED_MODERATED_AT } from './graphql';
import { Container } from './style';

const IsBannedModeratedComponent = (props) => {
  const {
    valueFormatted,
    value,
    data,
    setValue,
  } = props;
  // when the toggle is ON = NOT BANNED
  // when the toggle is OFF = BANNED
  // default is ON, and the field is null, if has value, then it is BANNED
  const cellValue = !(valueFormatted || value);

  const [checked, setChecked] = useState(cellValue);
  const [updateUserBanModerated, { error }] = useMutation(UPDATE_IS_BANNED_MODERATED_AT);

  const onChangeToggle = async (event) => {
    const isChecked = event.target.checked;
    // isBannedModerated if it is null, means not banned, otherwise banned
    const params = {
      variables: {
        userId: data?.id,
        isBannedModeratedAt: !isChecked,
      },
    };
    setChecked(isChecked);
    await updateUserBanModerated(params);
    setValue(isChecked);
  };

  useEffect(() => {
    if (error) {
      // eslint-disable-next-line no-alert
      alert('Error updating user ban moderated, please refresh and try again');
    }
  }, [error]);

  return (
    <Container>
      <Toggle
        checked={checked}
        onChange={onChangeToggle}
        id={`toggle-${data?.id}`}
      />
    </Container>
  );
};

IsBannedModeratedComponent.propTypes = {
  valueFormatted: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  data: PropTypes.shape({
    id: PropTypes.string,
  }).isRequired,
  setValue: PropTypes.func.isRequired,
};

export default IsBannedModeratedComponent;
